module.exports = __webpack_public_path__ + "static/videos/litho_001.4372f37.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/litho/litho_001.mp4
// module id = 470
// module chunks = 1